export const isElementWrappedInCloser = (element: Element, parentClassName?: string): boolean =>
	element.parentElement?.tagName === 'DIV' &&
	element.previousElementSibling?.tagName === 'BUTTON' &&
	element.parentElement.className === (parentClassName ?? `mce-${element.tagName.toLowerCase()}`);

export const wrapElementInCloser = (element: Element, parentClassName?: string): Element => {
	const clonedElement = element.cloneNode();
	const wrapper = document.createElement('div');
	wrapper.className = parentClassName ?? `mce-${element.tagName.toLowerCase()}`;
	wrapper.setAttribute('contentEditable', 'false');
	const closeButton = document.createElement('button');
	closeButton.className = 'closer';
	wrapper.appendChild(closeButton);
	wrapper.appendChild(clonedElement);
	return wrapper;
};

export function isVideoElement(element: Element): boolean {
	return element.querySelectorAll('iframe.video-frame').length > 0 && element.tagName === 'SPAN';
}
